import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpDeleteAccesses} from '../http/accesses.http'
import {QUERY_KEYS} from '@/queryClient'
import {errorHandler} from '@/utilities/helpers'

export const useDeleteAccess = (accessId: string, options?: Omit<UseMutationOptions, 'mutationFn'>) => {
    const queryClient = useQueryClient()

    return useMutation({
        ...options,
        mutationFn: () => httpDeleteAccesses({urlParams: {accessId}}),
        onSuccess: async (data, variables, context) => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESSES]})
            await options?.onSuccess?.(data, variables, context)
        },
        onError: (error, variables, context) => {
            errorHandler(error)
            options?.onError?.(error, variables, context)
        }
    })
}
